// src/utils/secureStorage.js - نسخة محسّنة مع مفتاح مشتق

class SecureStorage {
  constructor() {
    if (SecureStorage.instance) {
      return SecureStorage.instance;
    }
    this.encryptionKey = this.deriveKey();
    SecureStorage.instance = this;
  }

  /**
   * اشتقاق مفتاح من خصائص المتصفح 
   */
  deriveKey() {
    const fingerprint = [
      navigator.userAgent,
      navigator.language,
      window.screen.colorDepth,
      window.screen.width + 'x' + window.screen.height,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      // salt ثابت للتطبيق
      'HC_SECURE_SALT_v2'
    ].join('|');

    // تحويل الـ fingerprint لمفتاح 64 حرف
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }

    // توسيع المفتاح لـ 64 حرف
    const base = Math.abs(hash).toString(16).padStart(8, '0');
    let key = '';
    for (let i = 0; i < 8; i++) {
      key += base;
    }
    return key;
  }

  simpleEncrypt(text, key) {
    try {
      const utf8Bytes = new TextEncoder().encode(text);
      const binaryString = String.fromCharCode(...utf8Bytes);
      let result = '';
      for (let i = 0; i < binaryString.length; i++) {
        result += String.fromCharCode(
          binaryString.charCodeAt(i) ^ key.charCodeAt(i % key.length)
        );
      }
      return btoa(result);
    } catch (error) {
      console.error('Encryption error:', error);
      throw error;
    }
  }

  simpleDecrypt(encryptedText, key) {
    try {
      const text = atob(encryptedText);
      let binaryString = '';
      for (let i = 0; i < text.length; i++) {
        binaryString += String.fromCharCode(
          text.charCodeAt(i) ^ key.charCodeAt(i % key.length)
        );
      }
      const utf8Bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
      return new TextDecoder().decode(utf8Bytes);
    } catch (error) {
      console.error('Decryption error:', error);
      return null;
    }
  }

  generateChecksum(data) {
    let hash = 0;
    for (let i = 0; i < data.length; i++) {
      const char = data.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return hash.toString();
  }

  setItem(key, value, storage = sessionStorage) {
    try {
      if (process.env.NODE_ENV === 'development' && storage === localStorage && key.includes('token')) {
        console.warn('⚠️ تخزين التوكنات في localStorage غير آمن!');
      }
      const encrypted = this.simpleEncrypt(value, this.encryptionKey);
      const data = {
        value: encrypted,
        timestamp: Date.now(),
        checksum: this.generateChecksum(encrypted)
      };
      storage.setItem(key, JSON.stringify(data));
    } catch (error) {
      console.error('خطأ في التخزين الآمن:', error);
    }
  }

  getItem(key, storage = sessionStorage) {
    try {
      const stored = storage.getItem(key);
      if (!stored) return null;

      const data = JSON.parse(stored);

      if (data.checksum !== this.generateChecksum(data.value)) {
        console.warn('⚠️ تم اكتشاف تلاعب في البيانات:', key);
        storage.removeItem(key);
        return null;
      }

      return this.simpleDecrypt(data.value, this.encryptionKey);
    } catch (error) {
      console.error('خطأ في استرداد البيانات:', error);
      return null;
    }
  }

  cleanExpiredData() {
    const maxAge = 8 * 60 * 60 * 1000;
    [sessionStorage].forEach(storage => {
      Object.keys(storage).forEach(key => {
        try {
          const rawData = storage.getItem(key);
          if (rawData?.startsWith('{') && rawData.includes('"timestamp"')) {
            const data = JSON.parse(rawData);
            if (data.timestamp && (Date.now() - data.timestamp > maxAge)) {
              storage.removeItem(key);
            }
          }
        } catch { }
      });
    });
  }

  clearAll() {
    sessionStorage.clear();
    const localStorageKeys = [
      'adminToken', 'adminPermissions', 'agentToken',
      'agentPermissions', 'userRole', 'clientData',
      'clientData_persistence', 'client_data',
    ];
    localStorageKeys.forEach(key => localStorage.removeItem(key));
  }
}

const secureStorageInstance = new SecureStorage();
Object.freeze(secureStorageInstance);

export { secureStorageInstance as SecureStorage };
export default secureStorageInstance;